import React from 'react';
import { Button } from 'devextreme-react';
import { useNavigate } from 'react-router-dom';
import './BackButton.scss';
import { useAppDispatch } from 'store/app/hooks';
import { setSelectedReportClient } from 'cui/components/breadcrumb/breadcrumb.slice';
import { selectedApplication } from '../../../../store/app/applications.slice';

interface BackButtonProps {
	sharedApplication?: string;
	currentClient?: string;
	currentEngagement?: string;
}

export const BackButton: React.FunctionComponent<BackButtonProps> = (props) => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const sharedApplication = props.sharedApplication;
	const currentClient = props.currentClient;
	const currentEngagement = props.currentEngagement;

	const onBackClick = async () => {
		if(sharedApplication && currentClient && currentEngagement){
			try {
				dispatch((selectedApplication(sharedApplication)));
				dispatch(setSelectedReportClient(currentClient));
				navigate(`/applications/${sharedApplication}/${currentClient}/${currentEngagement}`);
			}
			catch {
				navigate('/');
			}
		}
		else{
			navigate(-1);
		}
	}

	return (
			<Button
				stylingMode="outlined"
				onClick={onBackClick}
			>
				<span className="dx-icon-arrowleft" />
			</Button>
	);
};